import * as React from 'react';
import { selectToken } from '../../util/tokenSelector.js';
import { Box } from '../Box/Box.js';
import { Icon } from '../Icon/Icon.js';
import { Typography } from '../Typography/Typography.js';
import { useThemeContext } from '../../contexts/session/Theme.js';

var TooltipListItem = function TooltipListItem(props) {
  var theme = useThemeContext();
  var listColumnGap = selectToken(theme.spacing, '24');
  return /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    justifyContent: props.caption ? 'space-between' : undefined,
    flexBasis: !props.caption ? "calc(50% - (".concat(listColumnGap, " / 2))") : undefined,
    role: "listitem"
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex"
  }, props.icon ? /*#__PURE__*/React.createElement(Icon, {
    id: props.icon,
    size: "16",
    me: "8"
  }) : /*#__PURE__*/React.createElement(Typography, {
    variant: "body-s",
    me: "8"
  }, "\u2022"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body-s"
  }, props.label)), props.caption && /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    maxWidth: "50%",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption-default",
    textAlign: "end"
  }, props.caption)));
};
TooltipListItem.displayName = 'TooltipListItem';

export { TooltipListItem };
//# sourceMappingURL=TooltipListItem.js.map
